import { stateKeys } from '../../types';

export const getVideoList = (state) => state[stateKeys.GUIDES].videoList;
